import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/customer/schema";
import { convertNativeToCustom } from "services/utility/customFields";
import { htmlEncode } from "services/utility/parsing";

export function beforeSave(record) {
  const newRecord = { ...record };

  newRecord.customFields = convertNativeToCustom(record.customFields);

  // unset tax exempt reason ID if the customer is taxable
  if (newRecord.tax?.taxable && newRecord.tax?.taxExemptReasonId) {
    newRecord.tax.taxExemptReasonId = null;
  }

  // HTML encode relevant fields
  if (FIELDS_TO_TRANSFORM.HTML_ENCODED_FIELDS) {
    FIELDS_TO_TRANSFORM.HTML_ENCODED_FIELDS.forEach((field) => {
      newRecord[field] = htmlEncode(newRecord[field]);
    });
  }

  if (newRecord.tax && !newRecord.tax.taxable) {
    newRecord.tax.taxCode = null;
  }

  return newRecord;
}
